import styles from './TypingLoader.module.css';

export const TypingLoader = () => (
    <div className={styles['typing-loader']}>
        <span className={styles['typing-loader__dot']} />
        <span className={styles['typing-loader__dot']} />
        <span className={styles['typing-loader__dot']} />
    </div>
);
